// File: src/app/services/abandon-email-rest.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { getAdobeECID } from '../shared/utils/adobe-ecid';
import { uuid } from '../shared/utils/uuid';
import { RuntimeConfigService } from './runtime-config';

export interface CreateAbandonEmailInput {
  email: string;
  firstName?: string;
  lastName?: string;
  mobilePhone?: string;
}

/**
 * Persists partial lead contact info when a customer leaves mid-form so
 * follow-up email can be sent (`POST /api/email/abandon`).
 */
@Injectable({
  providedIn: 'root',
})
export class AbandonEmailRestService {
  private readonly endpoint: string;

  constructor(private http: HttpClient, private config: RuntimeConfigService) {
    this.endpoint = this.config.prequalConfig.WWW_REST_API_URI;
  }

  createAbandonEmail(input: CreateAbandonEmailInput): Observable<boolean> {
    return getAdobeECID().pipe(
      take(1),
      switchMap((ecid) => {
        const headers = {
          'x-correlation-id': uuid(),
          'x-ecid': ecid || '',
        };
        return this.http.post<boolean>(
          this.endpoint + '/api/email/abandon',
          input,
          { headers }
        );
      })
    );
  }
}
